import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { useClipboard } from 'foxact/use-clipboard';
import ms from 'ms';
import { useRef, useState } from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
export function VocabularyMenu(t0) {
  const $ = _c(26);
  const {
    tabIndex,
    word
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      timeout: ms("1s")
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    copy,
    copied,
    error
  } = useClipboard(t1);
  const t2 = `Copy ${word}`;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("size-full min-w-(--leading) flex-wrap content-center items-start p-0 [--sq-r:.5rem]");
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== copy || $[3] !== word) {
    t4 = () => copy(word);
    $[2] = copy;
    $[3] = word;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = copied ? "" : "hidden";
  let t6;
  if ($[5] !== t5) {
    t6 = cn("icon-[mingcute--check-fill]", t5);
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6) {
    t7 = <svg className={t6} />;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = error ? "" : "hidden";
  let t9;
  if ($[9] !== t8) {
    t9 = cn("icon-[bx--bxs-error-circle] text-red-500", t8);
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t9) {
    t10 = <svg className={t9} />;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  const t11 = copied || error ? "hidden" : "";
  let t12;
  if ($[13] !== t11) {
    t12 = cn("icon-[ooui--copy-ltr] transition-opacity delay-50 duration-100 group-hover:opacity-100", t11);
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t12) {
    t13 = <svg className={t12} />;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t10 || $[18] !== t13 || $[19] !== t7) {
    t14 = <div className="flex size-(--leading) items-center justify-center *:size-3!">{t7}{t10}{t13}</div>;
    $[17] = t10;
    $[18] = t13;
    $[19] = t7;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t14 || $[22] !== t2 || $[23] !== t4 || $[24] !== tabIndex) {
    t15 = <Button aria-label={t2} tabIndex={tabIndex} variant="ghost" className={t3} onClick={t4}>{t14}</Button>;
    $[21] = t14;
    $[22] = t2;
    $[23] = t4;
    $[24] = tabIndex;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  return t15;
}
export function VocabularyWordAction(t0) {
  const $ = _c(22);
  const {
    isMuted,
    word
  } = t0;
  const rootRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState("top");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function openAction() {
      const root = rootRef.current;
      const tableHead = root?.closest("table")?.querySelector("thead");
      if (root && tableHead) {
        const {
          top
        } = root.getBoundingClientRect();
        const {
          bottom
        } = tableHead.getBoundingClientRect();
        setPlacement(top - 24 <= bottom + 2 ? "inline" : "top");
      }
      setOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const openAction = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = event => {
      const nextFocusTarget = event.relatedTarget;
      if (!(nextFocusTarget instanceof Node) || !event.currentTarget.contains(nextFocusTarget)) {
        setOpen(false);
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setOpen(false);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setOpen(false);
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = isMuted ? "text-neutral-500 dark:text-neutral-400" : "";
  let t6;
  if ($[4] !== t5) {
    t6 = clsx("rounded-lg px-1 py-0.5 transition-colors delay-100 hover:bg-background-focus", t5);
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t6 || $[7] !== word) {
    t7 = <span className={t6}>{word}</span>;
    $[6] = t6;
    $[7] = word;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = !open;
  const t9 = placement === "inline" ? "top-1/2 left-[calc(100%+2px)] -translate-y-1/2" : "right-0 bottom-[calc(100%-2px)]";
  const t10 = open ? "opacity-100" : "pointer-events-none opacity-0";
  let t11;
  if ($[9] !== t10 || $[10] !== t9) {
    t11 = clsx("absolute z-999999999 flex size-6 justify-center rounded-md border bg-popover p-0.5 text-popover-foreground shadow-md transition-opacity duration-100 ease-out", t9, t10);
    $[9] = t10;
    $[10] = t9;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const t12 = open ? 0 : -1;
  let t13;
  if ($[12] !== t12 || $[13] !== word) {
    t13 = <VocabularyMenu tabIndex={t12} word={word} />;
    $[12] = t12;
    $[13] = word;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== t11 || $[16] !== t13 || $[17] !== t8) {
    t14 = <span aria-hidden={t8} className={t11}>{t13}</span>;
    $[15] = t11;
    $[16] = t13;
    $[17] = t8;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t14 || $[20] !== t7) {
    t15 = <span ref={rootRef} className="relative inline-block cursor-text pl-1 tracking-[.04em] select-text" onBlurCapture={t2} onClick={_temp} onFocusCapture={openAction} onMouseEnter={openAction} onMouseLeave={t3} onPointerEnter={openAction} onPointerLeave={t4}>{t7}{t14}</span>;
    $[19] = t14;
    $[20] = t7;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  return t15;
}
function _temp(event_0) {
  return event_0.stopPropagation();
}